import { render, staticRenderFns } from "./IconInb.vue?vue&type=template&id=0dc6e594&scoped=true"
import script from "./IconInb.vue?vue&type=script&lang=js"
export * from "./IconInb.vue?vue&type=script&lang=js"
import style0 from "./IconInb.vue?vue&type=style&index=0&id=0dc6e594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6e594",
  null
  
)

export default component.exports